/* eslint-disable no-unused-vars */
import { useEffect, useState, createContext } from "react";
import "./main.css";
import "antd/dist/antd.css";
//import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import Layout from "./layouts/Layout";
import { PermissionsProvider } from "./context/PermissionContext";
import SessionActivityTracker from "./services/sessionActivityTracker";
import { refreshUserToken, clearUserAuthData } from "./services/authRefresh";

export const ContextApi = createContext();

function App() {

  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [contextData, setContextData] = useState({
    isEdit: false,
    isDeletedArr: [],
  });

  // SSO session sync: detect Sampark logout and auto-logout DH
  // Triggers on tab focus, tab visibility change, and every 30s
  // Only runs for SSO users (those with a refresh_token stored)
  // No existing functionality is affected
  useEffect(() => {
    const checkSSOSession = async () => {
      const refreshToken = localStorage.getItem("user.refresh_token");
      const userId = localStorage.getItem("user.id");
      // Skip non-SSO users and users who are not logged in
      if (!refreshToken || !userId) return;
      try {
        await refreshUserToken();
      } catch (err) {
        // Only force logout if Keycloak explicitly rejected the token (401)
        // Ignore network errors / server downtime to avoid false logouts
        if (err?.response?.status === 401) {
          clearUserAuthData();
          window.location.replace("/");
        }
      }
    };

    // Check on tab visibility restore (user switches back to DH tab)
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkSSOSession();
      }
    };

    // Check on window focus (Alt+Tab or click back to DH)
    const handleFocus = () => checkSSOSession();

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    // Fallback: poll every 30 seconds for the case user never leaves the DH tab
    const interval = setInterval(checkSSOSession, 30000);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
      clearInterval(interval);
    };
  }, []);

  return (
    <ContextApi.Provider
      value={{ contextData, setContextData, isMenuExpanded, setIsMenuExpanded }}
    >
      <BrowserRouter>
        <PermissionsProvider>
          <SessionActivityTracker />
          <Layout />
        </PermissionsProvider>
      </BrowserRouter>
    </ContextApi.Provider>
  );
}

export default App;
